import { Fragment } from 'react';

import { HomepageNavbar } from './HomepageNavbar';

import { Homepage } from './Homepage';

export const HomepageRoute = (): JSX.Element => (
    <Fragment>
        <HomepageNavbar />
        <Homepage />
    </Fragment>
);
